import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import memoize from 'memoize-one';
import { Route } from 'react-router-dom';
import LoadingOverlay from '../../components/_molecules/LoadingOverlay/LoadingOverlay';
import ErrorModal from '../../components/_molecules/ErrorModal/ErrorModal';
import { LOADING, ERROR, publicHash } from '../../utils/constants';
import ChartPart from './components/ChartPart/ChartPart';
import TablePart from './components/TablePart/TablePart';
import './MainPanel.scss';
import CreateApp from '../CreateApp';
import ArrowButton from '../../components/_atomic/ArrowButton/ArrowButton';
import { getClientLastURL, setClientLastURL } from '../../utils/helpers';

class MainPanel extends Component {
  static propTypes = {
    getAppCampaigns: PropTypes.func.isRequired,
    getAppCampaignsStatus: PropTypes.string.isRequired,
    getAppCampaignsError: PropTypes.string.isRequired,
    currentAppCampaigns: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    getChartReport: PropTypes.func.isRequired,
    chartReport: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    getChartCompareReport: PropTypes.func.isRequired,
    chartCompareReport: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    getTableReport: PropTypes.func.isRequired,
    tableReport: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    patchCampaign: PropTypes.func.isRequired,
    patchCampaignStatus: PropTypes.string.isRequired,
    patchCampaignError: PropTypes.string.isRequired,
    annulPatchError: PropTypes.func.isRequired,
    resetChartCompareReport: PropTypes.func.isRequired,
    match: PropTypes.shape({}).isRequired,
    location: PropTypes.shape({}).isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    apps: PropTypes.arrayOf(PropTypes.shape({})),
    changeSideAppId: PropTypes.func.isRequired,
    getExport: PropTypes.func.isRequired,
    isAdmin: PropTypes.bool.isRequired,
    getApp: PropTypes.func.isRequired,
    // currentEditableApp: PropTypes.shape({}),
    resetChartReport: PropTypes.func.isRequired,
    changeAdminBarId: PropTypes.func,
    getCurrentDate: PropTypes.func.isRequired,
    currentDate: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    getEvents: PropTypes.func.isRequired,
    updateEvents: PropTypes.func.isRequired,
    updateAdminTable: PropTypes.func.isRequired,
    updateUserTable: PropTypes.func.isRequired,
    setEvents: PropTypes.func.isRequired,
    deleteNotActualTableAdmin: PropTypes.func.isRequired,
    deleteNotActualTableUser: PropTypes.func.isRequired,
    accessedEvents: PropTypes.arrayOf(PropTypes.shape({})),
    currentEvents: PropTypes.arrayOf(PropTypes.shape({})),
    setAdminTable: PropTypes.func.isRequired,
    setUserTable: PropTypes.func.isRequired,
    adminTable: PropTypes.arrayOf(PropTypes.shape({})),
    userTable: PropTypes.arrayOf(PropTypes.shape({})),
    updateEventTableAdmin: PropTypes.func.isRequired,
    updateEventTableUser: PropTypes.func.isRequired,
    sidebarStatus: PropTypes.bool,
    datePicker: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    updateDatePicker: PropTypes.func.isRequired,
  };
  static defaultProps = {
    apps: [],
    userTable: [],
    adminTable: [],
    currentEvents: [],
    accessedEvents: [],
    sidebarStatus: true,
    // currentEditableApp: {},
    changeAdminBarId: () => {},
  };
  state = {

  };
  componentWillMount() {
    const {
      apps,
      match: {
        params: { appId },
      },
      history,
      isAdmin,
      getApp,
    } = this.props;
    if (isAdmin) {
      if (appId) {
        getApp({ appId });
      } else {
        const storageUrlKey = getClientLastURL();
        const replaceDev = storageUrlKey.replace('/dev', '');
        if (storageUrlKey.indexOf('null') < 0) {
          if (replaceDev === '/app/me') {
            history.push(`${publicHash}/app/overview`);
          } else if (replaceDev === '/false') {
            history.push(`${publicHash}/app/overview`);
          } else {
            history.push(`${publicHash}${replaceDev}`);
          }
        } else {
          history.push(`${publicHash}/app/overview`);
        }
        // history.push(`${publicHash}/app/overview`);
      }
    } else if (apps.length) {
      if (appId) {
        const currentIndex = apps.findIndex(app => Number(app.id) === Number(appId));
        if (currentIndex > -1) {
          this.props.changeSideAppId(apps[currentIndex].id);
        }
      } else {
        history.push(`${publicHash}/app/${apps[0].id}/campaigns`);
        this.props.changeSideAppId(apps[0].id);
      }
    }
  }
  componentDidUpdate(prevProps) {
    const {
      apps,
      match: {
        params: { appId },
      },
      history,
      isAdmin,
    } = this.props;
    if (!isAdmin && JSON.stringify(apps) !== JSON.stringify(prevProps.apps)) {
      if (apps.length) {
        if (appId) {
          const currentIndex = apps.findIndex(app => Number(app.id) === Number(appId));
          if (currentIndex > -1) {
            this.props.changeSideAppId(apps[currentIndex].id);
          }
        } else {
          const storageKey = getClientLastURL();
          const replaceDev = storageKey.replace('/dev', '');
          if (storageKey.indexOf('null') < 0) {
            if (replaceDev === '/app/me') {
              history.push(`${publicHash}/app/${apps[0].id}/campaigns`);
              this.props.changeSideAppId(apps[0].id);
            } else if (replaceDev === '/false') {
              history.push(`${publicHash}/app/${apps[0].id}/campaigns`);
              this.props.changeSideAppId(apps[0].id);
            } else {
              history.push(`${publicHash}${replaceDev}`);
              this.props.changeSideAppId(apps[0].id);
            }
          } else {
            history.push(`${publicHash}/app/${apps[0].id}/campaigns`);
            this.props.changeSideAppId(apps[0].id);
          }
        }
      } else {
        history.push(`${publicHash}/app/add-new`);
      }
    }
    const locSubscriber = window.location.pathname.indexOf('auth');
    if (locSubscriber < 0) {
      setClientLastURL(window.location.pathname);
    }
  }

  getCurrentApp = memoize((apps, id) => apps.filter(app => Number(app.id) === Number(id))[0]);

  transformCampaignsForFilter = memoize((campaigns) => {
    const transformedCampaigns = campaigns.map(campaign => ({
      label: campaign.name,
      value: campaign.id,
    }));
    const firstElement = [
      {
        label: 'All',
        value: '',
      },
    ];
    return [...firstElement, ...transformedCampaigns];
  });
  navigateToCampaign = ({ appId, campaignId }) => {
    let navigateLink = `${publicHash}/app/campaign/${appId}`;
    if (campaignId) {
      navigateLink = `${navigateLink}/${campaignId}`;
    }
    this.props.history.push(navigateLink);
  };
  navigateToApp = (appId) => {
    this.props.history.push(`${publicHash}/app/${appId}/edit`);
  };
  navigateToAppCampaigns = () => {
    const { location } = this.props;
    if (location.pathname.indexOf('campaigns') === -1) {
      window.history.back();
    }
  };
  navigateBack = () => {
    window.history.back();
  }

  navigateToUserLogs = (userId) => {
    const { history: { push } } = this.props;
    push(`${publicHash}/app/client/${userId}/logs`);
  }

  render() {
    const {
      apps,
      getAppCampaigns,
      getAppCampaignsError,
      getAppCampaignsStatus,
      currentAppCampaigns,
      getChartReport,
      getChartCompareReport,
      chartCompareReport,
      chartReport,
      getTableReport,
      tableReport,
      patchCampaign,
      patchCampaignStatus,
      patchCampaignError,
      annulPatchError,
      resetChartCompareReport,
      location,
      getExport,
      resetChartReport,
      isAdmin,
      changeAdminBarId,
      getCurrentDate,
      currentDate,
      getEvents,
      setEvents,
      updateEvents,
      accessedEvents,
      currentEvents,
      setAdminTable,
      adminTable,
      updateAdminTable,
      updateEventTableAdmin,
      deleteNotActualTableAdmin,
      userTable,
      setUserTable,
      updateUserTable,
      updateEventTableUser,
      deleteNotActualTableUser,
      sidebarStatus,
      datePicker,
      updateDatePicker,
      match: {
        params: { appId },
      },
    } = this.props;
    const transformedCampaigns = this.transformCampaignsForFilter(currentAppCampaigns);
    const errorText = getAppCampaignsError || patchCampaignError;
    const isLoading = getAppCampaignsStatus === LOADING;
    const isError = patchCampaignStatus === ERROR;
    const buttonControlClassNames = classNames({
      'main-panel-control-wrapper': true,
      'is-app': location.pathname.indexOf('edit') > -1,
    });
    const currentApp = this.getCurrentApp(apps, appId) || {};
    return (
      <div className="main-panel-wrapper">
        <LoadingOverlay visible={isLoading} />
        <ErrorModal
          visible={isError}
          error={errorText}
          requestClose={annulPatchError}
        />

        <div className="main-panel-parameter-name">
          {isAdmin && <ArrowButton
            onClick={this.navigateBack}
            padLeft={sidebarStatus ? 35 : 20}
          />}
          <span>{currentApp.name}</span>
          <div className={buttonControlClassNames}>
            <button
              onClick={() => {
                this.navigateToAppCampaigns(appId);
              }}
              className="main-panel-button"
            >
              CAMPAIGNS
            </button>
            <button
              onClick={() => {
                this.navigateToApp(appId);
              }}
              className="main-panel-button"
            >
              INFO
            </button>
          </div>
        </div>
        <Route
          exact
          path={`${publicHash}/app/:appId?/campaigns/:userId?/`}
          render={({ match: { params: { userId } } }) => (

            <div className="campaign-part">
              <div className="chart-part-wrapper">
                <ChartPart
                  appCampaigns={currentAppCampaigns}
                  getAppCampaigns={getAppCampaigns}
                  resetCompare={resetChartCompareReport}
                  appId={Number(appId)}
                  isAdmin={isAdmin}
                  getChartReport={getChartReport}
                  chartReport={chartReport}
                  getChartCompareReport={getChartCompareReport}
                  chartCompareReport={chartCompareReport}
                  getExport={getExport}
                  resetChartReport={resetChartReport}
                  getTableReport={getTableReport}
                  tableReport={tableReport}
                  getCurrentDate={getCurrentDate}
                  updateDatePicker={updateDatePicker}
                />
              </div>
              <div className="divider" />
              <div className="table-part-wrapper">
                <TablePart
                  campaigns={transformedCampaigns}
                  getTableReport={getTableReport}
                  tableReport={tableReport}
                  appId={Number(appId)}
                  isAdmin={isAdmin}
                  patchCampaign={patchCampaign}
                  patchCampaignStatus={patchCampaignStatus}
                  navigateToCampaign={this.navigateToCampaign}
                  userId={userId}
                  navigateToUserLogs={this.navigateToUserLogs}
                  currentDate={`${currentDate}`}
                  accessedEvents={accessedEvents}
                  currentEvents={currentEvents}
                  getEvents={getEvents}
                  setEvents={setEvents}
                  updateEvents={updateEvents}
                  adminTable={adminTable}
                  setAdminTable={setAdminTable}
                  updateAdminTable={updateAdminTable}
                  updateEventTableAdmin={updateEventTableAdmin}
                  deleteNotActualTableAdmin={deleteNotActualTableAdmin}
                  userTable={userTable}
                  setUserTable={setUserTable}
                  updateUserTable={updateUserTable}
                  updateEventTableUser={updateEventTableUser}
                  deleteNotActualTableUser={deleteNotActualTableUser}
                  datePicker={datePicker}
                />
              </div>
            </div>
          )}
        />
        <div className="app-info-part">
          <Route
            path={`${publicHash}/app/:appId?/edit/:userId?/`}
            render={() =>
              (<CreateApp
                changeAdminBarId={changeAdminBarId}
                isAdmin={isAdmin}
                isFirstFlow={false}
              />)
            }
          />
        </div>
      </div>
    );
  }
}

export default MainPanel;



// WEBPACK FOOTER //
// ./src/containers/MainPanel/MainPanel.js